// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QXOQ","top":"styles_top__2BuRF"};